import { styled } from 'styled-components';
import THEME from '../../theme.js';
import Checkbox from '../Checkbox.js';
export const Page = styled.div `
  color: ${THEME.COLOR_PRIMARY};
  padding: 10px 0 36px;
  h2,
  h3,
  p {
    margin-top: 0;
  }
  p {
    line-height: 1.55;
  }
`;
export const Header = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  padding: 14px 0 24px;
  h2 {
    font-size: 28px;
    letter-spacing: -0.7px;
    margin: 0 0 8px;
    font-weight: 700;
  }
  p {
    color: ${THEME.TEXT_MUTED};
    margin: 0;
    max-width: 680px;
    font-size: 14px;
  }
  @media (max-width: 770px) {
    align-items: flex-start;
    flex-direction: column;
  }
`;
export const Heading = styled.div `
  display: flex;
  align-items: center;
  gap: 16px;
`;
export const BrandIcon = styled.div `
  width: 54px;
  height: 54px;
  flex-shrink: 0;
  display: grid;
  place-items: center;
  border-radius: 16px;
  background: ${THEME.COLOR_PRIMARY};
  color: white;
`;
export const Layout = styled.div `
  display: grid;
  grid-template-columns: minmax(0, 1fr) 330px;
  align-items: start;
  gap: 28px;
  @media (max-width: 1000px) {
    grid-template-columns: minmax(0, 1fr);
  }
`;
export const Toolbar = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 24px;
  h3 {
    font-size: 17px;
    margin: 0 0 4px;
  }
  p {
    font-size: 13px;
    color: ${THEME.TEXT_MUTED};
    margin: 0;
  }
`;
export const Group = styled.section `
  margin-bottom: 26px;
  > h3 {
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.7px;
    text-transform: uppercase;
    color: ${THEME.TEXT_MUTED};
    display: flex;
    align-items: center;
    gap: 8px;
    margin: 0 0 10px;
  }
`;
export const SourceGrid = styled.div `
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
  @media (max-width: 620px) {
    grid-template-columns: minmax(0, 1fr);
  }
`;
export const SourceCard = styled.div `
  display: flex;
  align-items: flex-start;
  gap: 4px;
  border: 1px solid ${(p) => (p.$selected ? THEME.COLOR_ACCENT : THEME.BORDER)};
  border-radius: 10px;
  background: ${(p) => (p.$selected ? THEME.SURFACE_INSET : THEME.COLOR_SECONDARY)};
  transition:
    border-color 0.15s,
    background 0.15s;
  &:hover {
    border-color: ${THEME.COLOR_ACCENT};
  }
  &:focus-within {
    outline: 2px solid ${THEME.ACCENT_BORDER};
    outline-offset: 2px;
  }
`;
export const SourceCheckbox = styled(Checkbox) `
  && {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    padding: 16px 0 16px 14px;
    margin: 0;
    flex: 1;
    min-width: 0;
  }
  && > input {
    flex-shrink: 0;
    width: 18px;
    height: 18px;
    margin: 2px 0 0;
  }
  && > div {
    max-width: none;
    flex: 1;
    min-width: 0;
  }
  strong {
    display: block;
    font-size: 13px;
    line-height: 1.5;
    margin-bottom: 4px;
  }
  span {
    display: block;
    color: ${THEME.TEXT_MUTED};
    font-size: 12px;
    line-height: 1.5;
  }
`;
export const Sidebar = styled.aside `
  position: sticky;
  top: 24px;
  border: 1px solid ${THEME.ACCENT_BORDER};
  border-radius: 14px;
  background: ${THEME.COLOR_SECONDARY};
  box-shadow: 0 5px 22px #200d5407;
  overflow: hidden;
  @media (max-width: 1000px) {
    position: static;
  }
`;
export const SummaryHeader = styled.div `
  padding: 23px 22px 20px;
  background: ${THEME.SURFACE_INSET};
  border-bottom: 1px solid ${THEME.BORDER};
  > svg {
    color: ${THEME.COLOR_ACCENT};
    margin-bottom: 12px;
  }
  h3 {
    font-size: 17px;
    margin: 0 0 6px;
  }
  p {
    font-size: 12px;
    color: ${THEME.TEXT_MUTED};
    margin: 0;
  }
`;
export const SummaryBody = styled.div `
  padding: 22px;
  > p {
    color: ${THEME.TEXT_MUTED};
    font-size: 12px;
    margin: 12px 0 0;
  }
`;
export const Selection = styled.div `
  font-size: 13px;
  > strong {
    display: block;
    margin-bottom: 12px;
  }
  > p {
    color: ${THEME.TEXT_SUBTLE};
    padding: 14px 0;
    margin-bottom: 0;
  }
  ul {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
    max-height: 180px;
    overflow: auto;
  }
  li {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    font-size: 11px;
    padding: 5px 8px;
    border-radius: 5px;
    background: ${THEME.SURFACE_MUTED};
  }
  li svg {
    color: ${THEME.COLOR_ACCENT};
  }
`;
export const SecurityNote = styled.div `
  border-top: 1px solid ${THEME.BORDER};
  padding: 16px 22px;
  display: flex;
  align-items: flex-start;
  gap: 8px;
  color: ${THEME.TEXT_MUTED};
  svg {
    flex-shrink: 0;
    margin-top: 2px;
  }
  p {
    font-size: 11px;
    margin: 0;
  }
`;
export const HelpCard = styled.details `
  background: ${THEME.COLOR_SECONDARY};
  border: 1px solid ${THEME.BORDER};
  border-radius: 10px;
  margin-top: 12px;
  font-size: 13px;
  summary {
    padding: 16px 18px;
    font-weight: 600;
    cursor: pointer;
  }
  p {
    padding: 0 18px;
    color: ${THEME.TEXT_MUTED};
  }
`;
export const Notice = styled.div `
  display: flex;
  align-items: flex-start;
  gap: 12px;
  background: #fff8e8;
  border: 1px solid #f0dfb2;
  border-radius: 10px;
  padding: 16px;
  margin: 18px 0;
  text-align: left;
  color: #75571e;
  svg {
    flex-shrink: 0;
  }
  p {
    margin: 0;
    font-size: 13px;
    line-height: 1.6;
  }
`;
export const Success = styled.div `
  border: 1px solid #c9e4d5;
  background: #f0faf4;
  border-radius: 10px;
  padding: 20px;
  margin-bottom: 24px;
  h3 {
    color: #26754a;
    display: flex;
    align-items: center;
    gap: 9px;
    font-size: 16px;
    margin-bottom: 10px;
  }
  p {
    font-size: 13px;
    margin-bottom: 12px;
    color: #4d6e5c;
  }
`;
export const QueryPreview = styled.pre `
  max-height: 300px;
  overflow: auto;
  text-align: left;
  border-radius: 8px;
  background: ${THEME.SURFACE_INSET};
  padding: 16px;
  font-size: 12px;
`;
export const Action = styled.div `
  margin-top: 20px;
`;
export const ButtonContents = styled.span `
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
`;
export const SourceActions = styled.div `
  margin: 12px 8px 0 0;
`;
//# sourceMappingURL=styles.js.map